
import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';
// import{sse_url} from '@/utils/baseUrl';

//任务设置列表
export async function getTasksList(params) {
    return post(erpserver+'/task/getTasksList', params, true)
}
//模板录入列表
export async function getTemplatesDropdownList(params) {
    return post(erpserver+'/template/getTemplatesDropdownList', params, true)
}
//保存任务设置
export async function saveTask(params) {
    return post(erpserver+'/task/saveTask', params, true)
}
//任务设置
export async function taskUsed(params) {
    return post(erpserver+'/task/taskUsed', params, true)
}
export async function voidTask(params) {
    return post(erpserver+'/task/voidTask', params, true)
}
//部门
export async function getDepartmentsList(params) {
    return post(erpserver+'/task/getDepartmentsList', params, true)
}
//车间
export async function getWorkshopsList(params) {
    return post(erpserver+'/task/getWorkshopsList', params, true)
}
//班组
export async function getTeamsList(params) {
    return post(erpserver+'/task/getTeamsList', params, true)
}
//岗位
export async function getStationsList(params) {
    return post(erpserver+'/task/getStationsList', params, true)
}